export const DropdownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.78003 5.66992L7.56003 9.44992L11.34 5.66992"
      stroke-width="1.89"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
